import { GameTagType } from "entities/tagTypes/types";

export const tagTypeOptions = [
  { value: GameTagType.THEME, label: "Theme Tag" },
  { value: GameTagType.SERVICE, label: "Service Tag" },
];
